import { render, staticRenderFns } from "./ModalBodyDerivate.vue?vue&type=template&id=21f23e6b&scoped=true"
import script from "./ModalBodyDerivate.vue?vue&type=script&lang=js"
export * from "./ModalBodyDerivate.vue?vue&type=script&lang=js"
import style0 from "./ModalBodyDerivate.vue?vue&type=style&index=0&id=21f23e6b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21f23e6b",
  null
  
)

export default component.exports